import styled from 'styled-components'
import { Type } from '../types'

export const ImgAllowCookies = styled.img`
  ${(props: Type) => props.theme?.allowCookies?.img};
`